<template>
  <div>
    <div v-if="!isFirstLoading" class="related-list-layout">
      <ul class="related-list">
        <li
          v-for="(thumb, index) in relatedCellList"
          :key="`related_thumb_${index}`"
          class="item"
        >
          <RelatedCell :thumb="thumb" />
        </li>
      </ul>
    </div>
    <div ref="scrollMonitor" />
  </div>
</template>
<script>
  import scrollMonitor from 'scrollmonitor'
  // todo: remove scroll monitor
  import {
    getVodRelatedContents,
    getMovieRelatedContents,
  } from '@/common/utils/request'
  import RelatedCell from '@/components/player/tabs/related/RelatedCell.vue'

  export default {
    name: 'RelatedContentList',
    components: {
      RelatedCell,
    },
    props: {
      section: {
        type: String,
        default: '',
      },
      contentInfo: {
        type: Object,
        default: () => ({}),
      },
      landingInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        relatedCellList: [],
        isLoading: true,
        isFirstLoading: true,
        watcher: null,
        endOfList: false,
        offset: 0,
        limit: 21,
      }
    },
    created() {
      this.fetchData()
    },
    mounted() {
      this.setScrollMonitor()
    },
    methods: {
      setScrollMonitor() {
        const monitorEl = this.$refs['scrollMonitor']
        this.watcher = scrollMonitor.create(monitorEl, 100)
        this.watcher.enterViewport(this.loadMore)
      },
      loadMore() {
        if (this.section === 'movie') {
          return
        }
        if (this.endOfList) {
          return
        }
        this.offset += this.limit
        this.fetchData()
      },
      throwError() {
        this.$events.$emit(
          'OPEN_PPV_TOAST',
          () => {},
          '관련 영상 정보를 가져오지 못했습니다.',
        )
      },
      async fetchDataMovie() {
        const movieId = this.contentInfo?.movieid || ''
        try {
          const { data } = await getMovieRelatedContents({
            movieid: movieId,
            offset: this.offset,
            limit: this.limit,
          })
          const { cell_toplist: cellTopList } = data || {}
          const { celllist: cellList } = cellTopList || {}
          this.endOfList = cellList.length < this.limit

          this.relatedCellList = [...this.relatedCellList, ...cellList]
        } catch (e) {
          this.throwError()
        } finally {
          this.isLoading = false
          this.isFirstLoading = false
        }
      },
      async fetchDataVod() {
        const programId = this.landingInfo?.program_id || ''
        const { landing_list: landingList = {} } = this.landingInfo
        const [relatedTab] = (landingList?.tab || []).filter(
          (tab) => tab?.type === 'related',
        )
        const relatedTabPath = relatedTab?.path.replace('/fz', '') || ''

        try {
          const { data } = await getVodRelatedContents({
            path: relatedTabPath,
            programid: programId,
            offset: this.offset,
            limit: this.limit,
          })
          const { cell_toplist: cellTopList } = data || {}
          const { celllist: cellList } = cellTopList || {}
          this.endOfList = cellList.length < this.limit

          this.relatedCellList = [...this.relatedCellList, ...cellList]
        } catch (e) {
          this.throwError()
        } finally {
          this.isLoading = false
          this.isFirstLoading = false
        }
      },
      fetchData() {
        this.isLoading = true
        return this.section === 'movie'
          ? this.fetchDataMovie()
          : this.fetchDataVod()
      },
    },
  }
</script>
<style scoped lang="scss">
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .related-list-layout {
    min-width: 1440px;
    margin: -40px 100px 0px 100px;
    padding-bottom: 80px;
  }
  .related-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: -11px;
  }
  .item {
    width: 406px;
    margin: 40px 0 0 11px;
  }
</style>
